<template>
  <div id="page-wrapper">
    <Breadcrumbs :crumbs="pageCrumbs" />
    <PageContent @page-loaded="pageLoaded" />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useMainStore } from '../../../stores/mainStore';
import { useHead, useRoute } from '#imports';
import { clientWorkWindowEvent } from '../../../helpers/event-dispatch-helpers';
import { getMetaTags, getTitlePropByMetadata } from '../../../helpers/metadata';
import PageContent from '../../../components/PageContent.vue';
import Breadcrumbs from '../../../components/global/Breadcrumbs.vue';
import { useAnchorTag } from '../../../composables/useAnchorTag';

definePageMeta({
  middleware: ['page-content'],
});

const mainStore = useMainStore();
const route = useRoute();
const { scrollToAnchor } = useAnchorTag();

const page = computed(() => mainStore.page);
const globals = computed(() => mainStore.globals);
const pathPrefix = computed(() => mainStore.pathPrefix);

const metainfo = {
  metaTitle: getTitlePropByMetadata(mainStore.page.metadata, mainStore.page.name),
  metaTags: getMetaTags(mainStore.page.metadata),
};

useHead({
  ...metainfo.metaTitle,
  meta: metainfo.metaTags,
});

const pageCrumbs = ref([]);

function getBreadcrumbs() {
  pageCrumbs.value.push({
    name: globals.value.info.school_name,
    link: `${pathPrefix.value}/`,
  });

  if (!page.value.breadcrumbs) return;

  page.value.breadcrumbs.forEach((breadcrumb) => {
    const { name, slug, type, url } = breadcrumb;

    let link = '';
    let target = '_self';

    if (type === 'link') {
      link = url;
      target = '_blank';
    } else if (type === 'page') {
      link = slug ? `${pathPrefix.value}/page/${slug}` : '';
    }

    pageCrumbs.value.push({ name, link, target });
  });
}

onMounted(() => {
  getBreadcrumbs();
});

function pageLoaded() {
  scrollToAnchor(route.hash);
  clientWorkWindowEvent('pageLoaded');
}
</script>
